module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Th.1377b73.woff";